export function updateQueryParams(
  queryParams: string,
  key: string,
  value: string | null
): string {
  if (value) {
    // Update or add the parameter
    return queryParams.includes(`${key}=`)
      ? queryParams.replace(new RegExp(`${key}=[^&]*`), `${key}=${value}`)
      : queryParams
        ? `${queryParams}&${key}=${value}`
        : `?${key}=${value}`;
  }
  // Remove the parameter if value is null
  return queryParams
    .replace(new RegExp(`[?&]?${key}=[^&]*`, 'g'), '')
    .replace(/&$/, ''); // Remove trailing &
}
